import axios from 'axios';

const save = (resposta) => axios.post('/fornecedor/respostas', resposta);

export default {
  save,
};
